import {
  DialogContent,
  DialogContentProps,
  createStyles,
  makeStyles,
} from '@material-ui/core';

import classnames from 'classnames';

const useStyles = makeStyles(theme =>
  createStyles({
    root: {
      overflowY: 'auto',
      padding: theme.spacing(1, 3),
      maxHeight: 550,

      scrollbarWidth: 'thin',

      // Force show scrollbar if content is scrollable (mimic OSX style)
      ['&::-webkit-scrollbar']: {
        ['-webkit-appearance']: 'none',
        width: 7,
      },

      ['&::-webkit-scrollbar-thumb']: {
        borderRadius: 4,
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
        ['-webkit-box-shadow']: '0 0 1px rgba(255,255,255,.5)',
      },
    },
    autoHeight: {
      maxHeight: 'none',
    },
    noMargin: {
      padding: 0,
    },
  }),
);

type DialogBodyProps = {
  variant?: 'dense';
  autoHeight?: boolean;
} & DialogContentProps;

export const DialogBody = ({
  variant,
  autoHeight,
  children,
  ...rest
}: DialogBodyProps) => {
  const classes = useStyles();
  const noMargin = variant === 'dense';

  return (
    <DialogContent
      className={classnames(classes.root, {
        [classes.noMargin]: noMargin,
        [classes.autoHeight]: autoHeight,
      })}
      {...rest}
    >
      {children}
    </DialogContent>
  );
};
